import { render, staticRenderFns } from "./CollectionImageShow.vue?vue&type=template&id=ef94a27c&"
import script from "./CollectionImageShow.vue?vue&type=script&lang=js&"
export * from "./CollectionImageShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports